export enum ProductItemOrder {
    NameAscending,
    NameDescending,
    PublicIdAscending,
    PublicIdDescending,
    CreationDateAscending,
    CreationDateDescending
}